import React from 'react';
import classnames from 'classnames';
import partial from 'lodash/partial';
import {func, object} from 'prop-types';
import {Dropdown} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

export default class UserDetailActionsButton extends React.Component {
  static propTypes = {
    user: object.isRequired,
    awardPoints: func.isRequired,
    awardSpins: func.isRequired,
    awardDays: func.isRequired,
    changeEmail: func.isRequired,
    changePassword: func.isRequired,
    revokeAmountOfPoints: func.isRequired,
    repairProfile: func.isRequired,
    deleteUser: func.isRequired,
    undeleteUser: func.isRequired,
    deleteUserData: func.isRequired
  };

  get options() {
    // if a user action function has not been passed in, then do not render in the dropdown.
    // any functions for which the user lacks sufficient permissions do not get passed in.

    const options = [
      this.props.awardPoints && {
        text: <FormattedMessage id='userManagement.userDetail.actions.awardPoints' />,
        onClick: this.props.awardPoints
      },
      this.props.awardSpins && {
        text: <FormattedMessage id='userManagement.userDetail.actions.awardSpins' />,
        onClick: this.props.awardSpins
      },
      this.props.awardDays && {
        text: <FormattedMessage id='userManagement.userDetail.actions.awardDays' />,
        onClick: this.props.awardDays
      },
      this.props.changeEmail && {
        text: "Change Email Address",
        onClick: this.props.changeEmail
      },
      this.props.changePassword && {
        text: <FormattedMessage id='userManagement.userDetail.actions.changePassword' />,
        onClick: this.props.changePassword
      },
      this.props.revokeAmountOfPoints && {
        text: <FormattedMessage id='userManagement.userDetail.actions.revokeAmountOfPoints' />,
        onClick: this.props.revokeAmountOfPoints
      },
      this.props.repairProfile && {
        text: <FormattedMessage id='userManagement.userDetail.actions.repairProfile' />,
        onClick: this.props.repairProfile
      },
      this.props.deleteOrUndeleteUser && {
        text: (
          <FormattedMessage
            id={`userManagement.userDetail.actions.${this.props.user.deleted ? 'undeleteUser' : 'deleteUser'}`} />
        ),
        onClick: this.props.deleteOrUndeleteUser
      },
      this.props.deleteUserData && {
        text: <FormattedMessage id='userManagement.userDetail.actions.deleteUserData'/>,
        onClick: this.props.deleteUserData
      }
    ];

    return options
      .filter(Boolean)
      .map(option => ({
        ...option,
        className: 'fadeInUp animResponse',
        onClick: partial(option.onClick, this.props.user)
      }));
  }

  render() {
    return (
      <Dropdown
        className={classnames('user-detail-actions-dropdown', {hidden: !this.options.length})}
        button
        primary
        options={this.options}
        text={<FormattedMessage id='userManagement.userDetail.actions.button' />} />
    );
  }
};



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/UserDetailActionsButton.jsx